module.exports = __webpack_public_path__ + "static/media/prinny-char.a8e9a394.png";